"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* globals module */
/**
 * @module maintenanceRoute
 * @description Baasic Platform Maintenance Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Maintenance Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var MaintenanceRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MaintenanceRoute, _super);
    function MaintenanceRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Maintenance route with route and query parameters.
         **/
        _this.applicationMaintenanceRoute = 'platform/maintenance/{id}';
        /**
         * Maintenance route with route and query parameters.
         **/
        _this.maintenanceRoute = 'platform/maintenance';
        return _this;
    }
    /**
     * Parses application maintenance route.
     * @method
     * @example maintenanceRoute.maintain(id);
     **/
    MaintenanceRoute.prototype.maintainApp = function (id) {
        return _super.prototype.baseUpdate.call(this, this.applicationMaintenanceRoute, id);
    };
    /**
     * Parses maintenance route.
     * @method
     * @example maintenanceRoute.maintain();
     **/
    MaintenanceRoute.prototype.maintain = function () {
        return _super.prototype.baseUpdate.call(this, this.maintenanceRoute, {});
    };
    var _a;
    MaintenanceRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MaintenanceRoute);
    return MaintenanceRoute;
}(common_1.BaseRoute));
exports.MaintenanceRoute = MaintenanceRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
